<template>
	<div>
		<div class="lesson-desc">
			<div class="lesson-desc-title">课程介绍</div>
			<div class="lesson-desc-text-wrapper">
				<div class="lesson-desc-text" v-html="data.content">

				</div>
			</div>
			<div class="lesson-desc-more" v-if="needMore" @click="showMore"><div></div></div>
		</div>
		<div class="lesson-team">
			<div class="lesson-team-title">教师团队</div>
			<ul class="lesson-team-items f-cbli">
				<!--<li class="lesson-team-item">
					<div class="lesson-team-avatar f-img-box">
						<img src="../index/teacher.png">
					</div>
					<div class="lesson-team-content">
						<div class="lesson-team-name">李文渊</div>
						<div class="lesson-team-text">实力派老师备受学生好评实力派老师备受学生好评实力派老师备受学生好评</div>
					</div>
				</li>-->
				<li class="lesson-team-item" v-for="item in teachers" @click="toTeacher(item.id)">
					<div class="lesson-team-avatar f-img-box">
						<img :src="item.avatar?item.avatar:'../../static/img/default-teacher.png'">
					</div>
					<div class="lesson-team-content">
						<div class="lesson-team-name">{{item.nick_name}}</div>
						<div class="lesson-team-text o2">{{item.profile}}</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="bar">
			<div class="bar-button"></div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:{},
				teachers:[],
				courseId:this.$route.params.courseId,
				id:this.$route.params.id,
				needMore:false
			}
		},
		created(){
      //获取导航参数
      function geturl_j2(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      }
      var v_key = geturl_j2('v_key');
      // if (!/Android|webOS|iPhone|iPod|BlackBerry|HarmonyOS/i.test(navigator.userAgent)) {
      //   window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      // }
      // 是不是手机/平板（移动设备）
      const ua = navigator.userAgent || '';
      const isMobile = /Mobile|Android|iPhone|iPod|webOS|BlackBerry|iPad|Tablet/i.test(ua);
      // 如果不是移动设备，才跳PC登录
      if (!isMobile) {
        window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      }
			//获取课程介绍
			this.$api.get("",{
				api:"/v1/course/read",
				course_id:this.courseId
			},res=>{
				this.data=res.data;
				this.$nextTick(this.checkMore)
			})
			//获取老师
			this.$api.get("",{
				api:"/v1/course/teacher_index",
				course_id:this.courseId
			},res=>{
				this.teachers=res.data;
			})
		},
		methods:{
			checkMore(){
				if(document.querySelector(".lesson-desc-text").offsetHeight>document.querySelector(".lesson-desc-text-wrapper").offsetHeight){
					this.needMore=true;
				}
			},
			showMore(){
				document.querySelector(".lesson-desc-text-wrapper").style.maxHeight="none";
				document.querySelector(".lesson-desc-more").style.display="none";
			},
			toTeacher(id){
				this.$router.push("/teacher-lesson/"+id);
			}
		}
	}
</script>

<style>
	.lesson-desc{
		margin:0 0.4rem;
		padding:0.533rem 0 0.493rem 0;
		border-bottom: 2px solid #e6e6e6;
	}
	.lesson-desc-title{
		font-size: 0.346rem;
		color:#999;
	}
	.lesson-desc-text-wrapper{
		overflow: hidden;
		max-height: 3.466rem;
	}
	.lesson-desc-more{
		position: relative;
		margin-top:-1rem;
		height:1rem;
		background:-webkit-linear-gradient(rgba(242,242,242,0),rgba(242,242,242,1));
	}
	.lesson-desc-more div{
		position: absolute;
		bottom:0;
		width:100%;
		height:0.16rem;
		text-align: center;
		background: url(../lesson-detail/more.png) center center no-repeat;
		background-size: 0.293rem;
	}
	.lesson-desc-text{
		margin-top:0.226rem;
		font-size: 0.373rem;
		color:#333;
		line-height: 0.666rem;
	}
	.lesson-desc-text img{
		max-width:100%!important;
	}
	.lesson-team{
		margin:0 0.4rem;
		padding:0.533rem 0 0.493rem 0;
	}
	.lesson-team-title{
		font-size: 0.346rem;
		color:#999;
	}
	.lesson-team-item{
		margin-top:0.533rem;
	}
	.lesson-team-avatar{
		overflow: hidden;
		float:left;
		width:2.16rem;
		height:2.16rem;
		border-radius: 50%;
	}
	.lesson-team-content{
		float:right;
		width:6.64rem;
		padding-top:0.253rem;
	}
	.lesson-team-name{
		font-size:0.4rem;
		color:#333;
		background: url(../lesson-detail/enter.png) right center no-repeat;
		background-size: 0.133rem;
	}
	.lesson-team-text{
		margin-top:0.293rem;
		font-size: 0.32rem;
		line-height:0.48rem;
		color:#666;
	}
</style>



// WEBPACK FOOTER //
// src/components/lesson-desc/lesson-desc.vue